import { Box, Grid, GridItem, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import HeadingCompo from "../AboutMe/HeadingCompo";
import GlassyBox from "../customComponents/GlassyBox";
import SkillsImage from "./SkillsImage";
// import github from "";

const Skills = () => {
  return (
    <Box id="Skills">
      <HeadingCompo>Skills</HeadingCompo>
      <Box mt="30px">
        <GlassyBox width="100%">
          <Grid
            templateColumns={{
              lg: "repeat(3, 1fr)",
              md: "repeat(2, 1fr)",
              sm: "repeat(1, 1fr)",
            }}
            color="#fff"
            gap="50px"
          >
            {SKILLS.map((skill) => (
              <GridItem key={skill.id}>
                <Text
                  m="auto"
                  w={"fit-content"}
                  borderBottomWidth="3px"
                  borderColor="teal"
                  mb="15px"
                  textAlign="center"
                  fontWeight={700}
                  fontSize={{ lg: "25px", md: "22px", sm: "19px" }}
                >
                  {skill.heading}
                </Text>
                <Box>
                  <Grid
                    templateColumns={{
                      lg: "repeat(2, 1fr)",
                      md: "repeat(3, 1fr)",
                      sm: "repeat(3, 1fr)",
                    }}
                  >
                    {skill.skills.map((el) => (
                      <GridItem key={el.id} m="auto">
                        <SkillsImage images={el.images} label={el.text} />
                      </GridItem>
                    ))}
                  </Grid>
                </Box>
              </GridItem>
            ))}
          </Grid>
        </GlassyBox>
      </Box>
    </Box>
  );
};

const SKILLS = [
  {
    id: 1,
    heading: "Front-End",
    skills: [
      {
        id: 10,
        images: ["./html.svg", "./html-color.svg"],
        text: "Html",
      },
      {
        id: 11,
        images: ["./css.svg", "./css-color.svg"],
        text: "Css",
      },
      {
        id: 12,
        images: ["./javascript.svg", "./javascript-color.svg"],
        text: "Javascript",
      },
      {
        id: 13,
        images: ["./react.svg", "./react-color.svg"],
        text: "React",
      },
      {
        id: 14,
        images: ["./redux.svg", "./redux-color.svg"],
        text: "Redux",
      },
      {
        id: 15,
        images: ["./typescript.svg", "./typescript-color.svg"],
        text: "Typescript",
      },
      {
        id: 16,
        images: ["./nextjs.svg", "./nextjs-color.svg"],
        text: "Next Js",
      },
      {
        id: 17,
        images: ["./chakra-ui.svg", "./chakra-ui-color.svg"],
        text: "Chakra Ui",
      },
    ],
  },
  {
    id: 2,
    heading: "Back-End",
    skills: [
      {
        id: 18,
        images: ["./nodejs.svg", "./nodejs-color.svg"],
        text: "NodeJS",
      },
      {
        id: 19,
        images: ["./mangodb.png", "./mangodb-color.png"],
        text: "MongoDB",
      },
      {
        id: 20,
        images: ["./expressJs.svg", "./expressJs-color.svg"],
        text: "ExpressJS",
      },
    ],
  },
  {
    id: 3,
    heading: "Tools",
    skills: [
      {
        id: 21,
        images: ["./git.svg", "./git-color.svg"],
        text: "Git",
      },
      {
        id: 22,
        images: ["./github.svg", "./github-color.svg"],
        text: "Github",
      },
      {
        id: 23,
        images: ["./vscode.svg", "./vscode-color.svg"],
        text: "VS Code",
      },
      {
        id: 24,
        images: ["./postman.svg", "./postman-color.svg"],
        text: "Postman",
      },
    ],
  },
];

export default Skills;
// ["./mango.svg", "./mango-color.svg"]
